import React from 'react'

function AlertSystem() {
  return (
    <div>
      
    </div>
  )
}

export default AlertSystem